import { Collapse, Typography } from "antd"
import cls from "classname"
import { NavLink } from "react-router-dom"

import Icon from "../../Icon"
import ArrowSelectDown from "../../Icon/img/ArrowSelectDown"
import ArrowSelectDownMobile from "../../Icon/img/ArrowSelectDownMobile"
import { openHideLink } from "../../Utils/utils"
import GettingStartedProgressIcon from "../GettingStartedPage/componets/GettingStartedProgressIcon"

import "./styles.less"

const { Panel } = Collapse
const { Text } = Typography

export const NavLinkWithIcon = ({
  url,
  withoutUrl,
  iconType,
  text,
  active,
  theme,
  isOpened,
  isSoon,
  isNotClickable,
  markText,
  markTextBordered,
  openSidebar,
  location,
  isDropdown,
  options,
  activeKey,
  setActiveKey,
  flag,
  t,
  isSetting = false,
  isMobile = false,
  isNew = false,
  isCustomAction,
  onClick,
  siderBarStatistics,
  tourGuideId,
  iconNode,
  ...props
}) => {
  const mouseOver = (e) => {
    let target = e.target
    const { scrollWidth, clientWidth } = target
    if (scrollWidth > clientWidth) target.classList.add("overflowing")
  }

  const mouseLeave = (e) => {
    let target = e.target
    target.classList.remove("overflowing")
  }

  return isDropdown && isOpened ? (
    <CollapsibleNavLink
      url={url}
      iconType={iconType}
      text={text}
      active={active}
      theme={theme}
      isOpened={isOpened}
      isSoon={isSoon}
      markTextBordered={markTextBordered}
      openSidebar={openSidebar}
      location={location}
      options={options}
      activeKey={activeKey}
      setActiveKey={setActiveKey}
      flag={flag}
      t={t}
      isNew={isNew}
      siderBarStatistics={siderBarStatistics}
      isNotClickable={isNotClickable}
      tourGuideId={tourGuideId}
      isMobile={isMobile}
    />
  ) : (
    <OptionalLink
      to={url}
      withoutUrl={withoutUrl}
      tourGuideId={tourGuideId}
      onClick={(e) => {
        setActiveKey([])
        if (isCustomAction && onClick) {
          e.preventDefault()
          e.stopPropagation()
          onClick()
          return e
        }
        if (isSoon || isNotClickable) {
          return e.preventDefault()
        } else {
          if (openSidebar) openSidebar()
          return e
        }
      }}
      className={cls("sidebar-link", {
        disabled: isSoon || isNotClickable,
        withoutUrl: withoutUrl
        // selected:
        // (url === '/sales-tracker/stores' && location?.includes('sales-tracker')) ||
        // (url === '/setting/account' && location?.includes('setting')) ||
        // (url === '/shop-finder/overview' && location === '/shop-finder/overview') ||
        // (url === '/shop-finder/collections' && location === '/shop-finder/collections'),
      })}
    >
      {iconNode ? (
        <>{iconNode}</>
      ) : (
        <Icon
          className="sidebar-link_icon"
          type={iconType}
          role="icon"
          outline={active}
          theme={theme}
          {...props}
        />
      )}
      {isOpened ? (
        <>
          {markText ? (
            <span
              className={cls("sidebar-link_mark", {
                "mark-text-bordered": markTextBordered
              })}
            >
              {markText}
            </span>
          ) : null}

          <span
            data-text={text}
            onMouseOver={mouseOver}
            onMouseLeave={mouseLeave}
            className={cls("sidebar-link-text", {
              setting: isSetting,
              disabled: isSoon || isNotClickable
            })}
          >
            {text}
            {isSetting && isMobile ? (
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="20"
                height="20"
                viewBox="0 0 20 20"
                fill="none"
              >
                <path
                  d="M8.33398 13.3337L11.0781 10.5896C11.4035 10.2641 11.4035 9.73651 11.0781 9.41107L8.33398 6.66699"
                  stroke="#707BA0"
                  strokeWidth="1.5"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
              </svg>
            ) : null}
            {/* {isNew ? <span className="dashboard-page-block-title-tag">new</span> : null} */}
          </span>
        </>
      ) : null}
    </OptionalLink>
  )
}

const CollapsibleNavLink = ({
  url,
  tourGuideId,
  iconType,
  text,
  active,
  theme,
  isOpened,
  isSoon,
  markTextBordered,
  openSidebar,
  location,
  options,
  activeKey,
  setActiveKey,
  flag,
  t,
  isNew,
  siderBarStatistics,
  isNotClickable,
  isMobile = false
}) => {
  const handleHeaderClick = (e) => {
    if (isNotClickable) {
      e.stopPropagation()
      e.preventDefault()
      return
    }
    setActiveKey(activeKey.includes(flag) ? [] : [flag])
    if (isSoon) {
      e.preventDefault()
    }
  }

  const isDropdownOpen = activeKey.includes(flag)

  return (
    <Collapse collapsible={"header"} ghost={true} activeKey={activeKey}>
      <Panel
        key={flag}
        showArrow={false}
        header={
          <NavLink
            to={url}
            onClick={handleHeaderClick}
            data-tour={tourGuideId}
            className={cls("sidebar-link sidebar-dropdown-link-main", {
              disabled: isSoon || isNotClickable,
              rotated: isDropdownOpen
            })}
          >
            <Icon
              className="sidebar-link_icon"
              type={iconType}
              role="icon"
              outline={active}
              theme={theme}
            />
            {isOpened ? (
              <span
                className={cls("sidebar-link-text", {
                  disabled: isSoon || isNotClickable
                })}
              >
                {text}
                {isNew && (
                  <span className="dashboard-page-block-title-tag dropdown">{t("new")}</span>
                )}
                <span className="sidebar-link-arrow">
                  {!isMobile ? <ArrowSelectDown /> : <ArrowSelectDownMobile />}
                </span>
              </span>
            ) : null}
          </NavLink>
        }
      >
        {options.map((el) => {
          const activeLink = location === el?.url
          return (
            <NavLink
              to={el?.url}
              key={el?.url}
              data-tour={el?.tourGuideId}
              onClick={(e) => {
                if (el?.isSoon || el?.isDisabled) {
                  return e.preventDefault()
                } else {
                  if (openSidebar) openSidebar()
                  return e
                }
              }}
              className={cls("sidebar-link sidebar-dropdown-link", {
                disabled: el?.isSoon || el?.isDisabled,
                active: activeLink
              })}
            >
              <>
                {el?.markText ? (
                  <span
                    className={cls("sidebar-link_mark", {
                      "mark-text-bordered": markTextBordered
                    })}
                  >
                    {t(el?.markText)}
                  </span>
                ) : null}
                <span
                  className={cls("sidebar-link-text", {
                    disabled: el?.isSoon || el?.isDisabled
                  })}
                >
                  {el?.text}
                </span>

                {el?.text === "All" && (
                  <Text type={!activeLink && "secondary"}>{siderBarStatistics.alerts}</Text>
                )}
                {el?.text === "Credits" && (
                  <Text type={!activeLink && "secondary"}>{siderBarStatistics.credits}</Text>
                )}
              </>
            </NavLink>
          )
        })}
      </Panel>
    </Collapse>
  )
}

function OptionalLink({ to, tourGuideId, withoutUrl, children, ...props }) {
  if (withoutUrl) {
    return (
      <span data-tour={tourGuideId} {...props}>
        {children}
      </span>
    )
  }
  return (
    <NavLink data-tour={tourGuideId} to={to} {...props}>
      {children}
    </NavLink>
  )
}

export const navIconsArr = {
  desktop: [
    {
      url: "/getting_started",
      iconDesk: "homesidebar",
      iconNode: <GettingStartedProgressIcon />,
      text: "Getting Started"
    },
    {
      url: "/dashboard",
      iconDesk: "homesidebar",
      text: "Dashboard",
      tourGuideId: "dashboard-nav"
    },
    {
      url: "/alerts",
      iconDesk: "alerts",
      text: "Alerts",
      flag: "alerts",
      markTextBordered: true,
      dropdown: true,
      tourGuideId: "alerts-nav",
      options: [
        { text: "All", url: "/alerts", key: "general" },
        { text: "Credits", url: "/credits", markText: null },
        {
          text: "Configure",
          url: "/configure",
          markText: null,
          tourGuideId: "configure-nav"
        }
      ]
    },
    {
      url: "/health/overview",
      iconDesk: "centralhub",
      text: "Health",
      flag: "health",
      markTextBordered: true,
      dropdown: true,
      //comingSoon: true,
      withDivider: true,
      requireCurBAHighAccessRole: true,
      disabledTooltip: "Available for Owner/Admin roles only",
      options: [
        { text: "Overview", url: "/health/overview", key: "general" },
        // { text: 'Chargebacks', url: '/health/chargebacks', markText: 'SOON', isSoon: true },
        { text: "Monitoring", url: "/health/monitoring" }
      ]
    },
    {
      url: "/team",
      iconDesk: "team",
      text: "Team",
      requireHighAccessRole: true,
      tourGuideId: "team-nav",
      disabledTooltip:
        "This action is restricted by your User Management settings for the current business account."
    },
    {
      url: "/integrations",
      iconDesk: "integrations",
      text: "Integrations",
      tourGuideId: "integrations-nav"
    },
    {
      url: "/digital-receipt",
      iconDesk: "receipt_bill",
      iconStyle: { fontSize: 20 },
      text: "Digital Receipt",
      markText: "SOON",
      onlyDemoModes: true
    }
  ],
  bottomMenu: [
    {
      url: "",
      withoutUrl: true,
      iconDesk: "Supportsidebar",
      text: "Support",
      isCustomAction: true,
      tourGuideId: "support-nav",
      onClick: () => window?.Intercom("show")
    },
    {
      url: "/help",
      iconDesk: "help_center",
      text: "Help center",
      isCustomAction: true,
      onClick: () => openHideLink("https://help.chargeback.io", "_blank"),
      tourGuideId: "help-nav"
      // isNotClickable: true,
    },
    {
      url: "/developers",
      iconDesk: "developer",
      text: "Developers",
      withDivider: true
    }
  ]
  // demo: [
  //   {
  //     url: '/dashboard',
  //     iconDesk: 'home',
  //     text: 'Dashboard',
  //   },
  //   {
  //     url: '/portfolio',
  //     iconDesk: 'portfolio',
  //     text: 'Portfolio',
  //     comingSoon: false,
  //     flag: 'portfolio',
  //     markTextBordered: true,
  //     withDivider: true,
  //     dropdown: true,
  //     options: [
  //       { text: 'My Portfolio', url: '/portfolio', key: 'general' },
  //       { text: 'Collections', url: '/collections', markText: null },
  //     ],
  //   },
  //   {
  //     url: '/suppliers',
  //     iconDesk: 'suppliers',
  //     text: 'Suppliers',
  //   },
  // ],
  // settingsDemo: [
  //   {
  //     url: '/setting/account',
  //     iconDesk: 'account',
  //     text: 'Account',
  //   },
  //   {
  //     url: '/setting/integrations',
  //     iconDesk: 'integrations',
  //     text: 'Integrations',
  //   },
  // ],
  // setting: [
  //   {
  //     url: '/setting/account',
  //     iconDesk: 'account',
  //     text: 'Account',
  //   },
  //   {
  //     url: '/setting/billing',
  //     iconDesk: 'billing',
  //     text: 'Billing',
  //   },
  //   {
  //     url: '/setting/plan',
  //     iconDesk: 'pln',
  //     text: 'Plan',
  //   },
  //   {
  //     url: '/setting/integrations',
  //     iconDesk: 'integrations',
  //     text: 'Integrations',
  //   },
  //   {
  //     url: '/setting/referral',
  //     iconDesk: 'referral',
  //     text: 'Referral',
  //   },
  // ],
}

export const navIconsAdmin = [
  // {
  //   url: '/admin/portfolio',
  //   iconDesk: 'portfolio',
  //   text: 'Portfolio',
  // },
  // {
  //   url: '/admin/database',
  //   iconDesk: 'database',
  //   text: 'Database',
  //   comingSoon: true,
  //   markText: 'soon',
  // },
  // {
  //   url: '/admin/droptimes',
  //   iconDesk: 'calendar',
  //   text: 'Drop times',
  // },
  // {
  //   url: '/admin/bd',
  //   iconDesk: 'b_d',
  //   text: 'Benefits & Drawbacks',
  // },
  // {
  //   url: '/admin/shopify',
  //   iconDesk: 'ali_drops',
  //   text: 'Shopify',
  // },
  // {
  //   url: '/admin/store-manager',
  //   iconDesk: 'settings',
  //   text: 'Store manager',
  // },
  // {
  //   url: '/admin/store-table',
  //   iconDesk: 'gps',
  //   text: 'Store table',
  // },
]
